import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as a}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const n=t("canada",a`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <rect
                width="24"
                height="16"
                transform="translate(0 4.5)"
                fill="white" />
            <path
                d="M0 4.5H6.64327V20.5H0V4.5ZM17.3567 4.5H24V20.5H17.3567V4.5ZM14.3392 14.1374L16.6971 12.9585L15.5181 12.369V11.1901L13.1602 12.369L14.3392 10.0111H13.1602L11.9813 8.24269L10.8023 10.0111H9.62339L10.8023 12.369L8.44444 11.1901V12.369L7.2655 12.9585L9.62339 14.1374L9.03392 15.3164H11.3918V17.0848H12.5708V15.3164H14.9287L14.3392 14.1374Z"
                fill="#FF0000" />
        </svg>
    `),i=a`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40008"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40008)">
            <g clip-path="url(#clip0_4915_40008)">
                <path
                    d="M-5.96484 0.492188H30.0352V24.4922H-5.96484V0.492188Z"
                    fill="white" />
                <path
                    d="M-5.96484 0.492188H4.00007V24.4922H-5.96484V0.492188ZM20.0702 0.492188H30.0352V24.4922H20.0702V0.492188ZM15.5439 14.9483L19.0808 13.1799L17.3123 12.2957V10.5273L13.7755 12.2957L15.5439 8.75885H13.7755L12.0071 6.10622L10.2387 8.75885H8.47024L10.2387 12.2957L6.70182 10.5273V12.2957L4.9334 13.1799L8.47024 14.9483L7.58603 16.7167H11.1229V19.3694H12.8913V16.7167H16.4281L15.5439 14.9483Z"
                    fill="#FF0000" />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_4915_40008">
                <rect
                    width="36"
                    height="24"
                    fill="white"
                    transform="translate(-5.96484 0.492188)" />
            </clipPath>
        </defs>
    </svg>
`,L=t("canada_rounded",i),d=t("CAD",i);export{d as CAD,n as Canada,L as CanadaRounded};
